import { render, staticRenderFns } from "./OsAlertBox.vue?vue&type=template&id=69ecaf30&scoped=true"
import script from "./OsAlertBox.vue?vue&type=script&lang=ts"
export * from "./OsAlertBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ecaf30",
  null
  
)

export default component.exports